import './StatusPill.css'

/**
 * Order-status pill colored per status — mirrors Prod's admin STATUS_PILL
 * palette (src/pages/admin/ui.jsx) exactly: pending=yellow, paid=green,
 * partial=orange, fulfilled/shipped=blue, cancelled=red, complete/delivered=gray.
 */
export default function StatusPill({ label, color = '#a3a3a3', className = '' }) {
  return (
    <span
      className={`ll-status-pill ${className}`.trim()}
      style={{ color, background: `${color}1a`, borderColor: `${color}55` }}
    >
      <span className="ll-status-pill__dot" style={{ background: color }} />
      {label}
    </span>
  )
}
